// @flow
import { get, isEmpty, isNil } from 'lodash';
import { resolve } from 'redux-optimist-promise';

import { SIGNOUT } from 'Store/user-info/actions/signout';
import { PROFILE_CHANGED } from 'Store/user-info/actions/notifyProfileChanged';
import {
  SET_ATTENDEES,
  TRIP_INFORMATION_UPDATE_ADULT,
} from 'Store/trip-information/adults/constants';
import { FETCH_PROPOSALS, FETCH_PROPOSALS_BY_ID } from 'Store/booking/proposals/constants';

export const MAIN_CONTACT_INDEX = 0;

type Address = {};

export type State = {|
  +GMNumber?: string,
  +unicodeCivility?: string,
  +civility?: string,
  +firstName?: string,
  +lastName?: string,
  +unicodeFirstName?: string,
  +unicodeLastName?: string,
  +dateOfBirth?: string,
  +email?: string,
  +homePhoneNumber?: ?string,
  +mobilePhoneNumber?: ?string,
  +isProspect?: boolean,
  +optinEmail?: boolean,
  +optinSms?: boolean,
  +optinMail?: boolean,
  +optinFosun?: boolean,
  +optinPhone?: boolean,
  +optinClubmedPlus?: boolean,
  +expirationDate?: number,
  +neolaneId?: string,
  +updatedDateOfBirth?: string,
  +address?: Address,
|};

// $FlowFixMe known flow bug. Faultly rejects empty object.
const initialState: State = {};

export default function userInfoReducer(state: State = initialState, action: Action<*>): State {
  switch (action.type) {
    case SIGNOUT:
      return initialState;
    case PROFILE_CHANGED:
      return {
        ...state,
        ...action.payload,
      };
    case SET_ATTENDEES:
    case resolve(FETCH_PROPOSALS):
    case resolve(FETCH_PROPOSALS_BY_ID):
      const { profile } = action.payload;
      // If profile is null, it means that the user is not logged or its token is not valid
      // and existing userInfo and no profile seems weird, but the token being short lived, it can
      // happen
      // address is nullable
      if (profile) {
        return {
          ...state,
          ...profile,
        };
      }

      return state;
    case TRIP_INFORMATION_UPDATE_ADULT:
      if (isEmpty(state)) return state;

      const { index, valuesToUpdate } = action.payload;
      const updatedDateOfBirth = get(valuesToUpdate, 'birthdate');
      const optinEmail = get(valuesToUpdate, 'optinEmail');
      const optinSms = get(valuesToUpdate, 'optinSms');
      const optinMail = get(valuesToUpdate, 'optinMail');
      const optinPhone = get(valuesToUpdate, 'optinPhone');
      const optinClubmedPlus = get(valuesToUpdate, 'optinClubmedPlus');

      if (index !== MAIN_CONTACT_INDEX) return state;

      let newState = state;
      if (updatedDateOfBirth) {
        newState = {
          ...newState,
          updatedDateOfBirth,
        };
      }

      if (!isNil(optinEmail)) {
        newState = {
          ...newState,
          optinEmail,
        };
      }

      if (!isNil(optinSms)) {
        newState = {
          ...newState,
          optinSms,
        };
      }

      if (!isNil(optinMail)) {
        newState = {
          ...newState,
          optinMail,
        };
      }
      if (!isNil(optinPhone)) {
        newState = {
          ...newState,
          optinPhone,
        };
      }
      if (!isNil(optinClubmedPlus)) {
        newState = {
          ...newState,
          optinClubmedPlus,
        };
      }

      return newState;
    default:
      return state;
  }
}
